import React, { useEffect, useState } from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { toast } from '../../hooks/use-toast';
import api from '../../services/api';

export const money = (v) => `AED ${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Hiring + visa + renewal spend per staff member (cost to company).
export const StaffCostOverview = () => {
  const [data, setData] = useState({ rows: [], totals: {} });
  const [q, setQ] = useState('');
  useEffect(() => { api.get('/api/hiring-costs/staff-summary').then((r) => setData(r.data)).catch(() => toast({ title: 'Could not load', variant: 'destructive' })); }, []);
  const download = async () => {
    const r = await api.get('/api/hiring-costs/staff-summary', { params: { format: 'xlsx' }, responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    Object.assign(document.createElement('a'), { href: url, download: 'staff_cost_to_company.xlsx' }).click();
    URL.revokeObjectURL(url);
  };
  const rows = data.rows.filter((r) => !q || `${r.name} ${r.employee_code} ${r.department}`.toLowerCase().includes(q.toLowerCase()));
  const t = data.totals;
  return (
    <div className="space-y-3" data-testid="hc-overview">
      <div className="flex flex-wrap items-center gap-2">
        <Input className="h-9 w-64" placeholder="Search staff…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="hc-overview-search" />
        <Button size="sm" variant="outline" className="ml-auto" onClick={download} data-testid="hc-overview-xlsx"><FileSpreadsheet className="h-4 w-4 mr-1" />Excel</Button>
      </div>
      <div className="border rounded-lg bg-white overflow-x-auto">
        <table className="w-full text-sm" data-testid="hc-overview-table">
          <thead className="bg-slate-50 text-[11px] uppercase text-gray-500">
            <tr>{['Employee', 'Department', 'Hiring cost', 'Visa cost', 'Renewals paid', 'Total cost'].map((h) => <th key={h} className="text-left px-3 py-2">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y">
            {rows.map((r) => (
              <tr key={r.employee_id} data-testid={`hc-overview-row-${r.employee_code}`}>
                <td className="px-3 py-2"><p className="font-medium">{r.name}</p><p className="text-xs text-gray-500">{r.employee_code}</p></td>
                <td className="px-3 py-2 text-gray-700">{r.department}</td>
                <td className="px-3 py-2">{money(r.hiring_cost)}</td>
                <td className="px-3 py-2">{money(r.visa_cost)}</td>
                <td className="px-3 py-2">{money(r.renewals_paid)}</td>
                <td className="px-3 py-2 font-semibold">{money(r.total)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot><tr className="bg-amber-50 font-semibold" data-testid="hc-overview-totals">
            <td className="px-3 py-2" colSpan={2}>Total (all staff)</td><td className="px-3 py-2">{money(t.hiring_cost)}</td><td className="px-3 py-2">{money(t.visa_cost)}</td><td className="px-3 py-2">{money(t.renewals_paid)}</td><td className="px-3 py-2">{money(t.total)}</td>
          </tr></tfoot>
        </table>
      </div>
    </div>
  );
};
